/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import { useLocation } from "react-router-dom";
// Data

import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";

// styles
import "./view_details.css";
// Dashboard components

function ViewDetail() {
  const location = useLocation();
  const data = location.state;
  console.log(data,'ooooooopppp');
  function formatKey(key) {
    // Use a regular expression to insert spaces before capital letters
    return key
      .replace(/([A-Z])/g, " $1")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  const Detailsrender = ({ object }) => {
    let obj = {...object}
    delete obj["variants"]
    delete obj["descriptionImages"]
    return (
      // <>
      //   {Object.entries(obj).map(([key, value], index) => (
      //     <div key={index}>
      //       <div className="content_div">
      //         <div className="key_wrapper">
      //           <span className="key">{formatKey(key)}</span>
      //         </div>
      //         <div className="key_wrapper">
      //           {key === "productImage" && value.startsWith("http") ? (
      //             <img src={value} alt="Product" style={{ width: "100px", height: "100px" }} />
      //           ) : (
      //             <span className="value">{value}</span>
      //           )}
      //         </div>
      //       </div>
      //       <hr />
      //     </div>
      //   ))}
      // </>
      <>
      {console.log(obj,'9999999')}
      {Object.entries(obj).map(([key, value], index) => (   
             
        <div key={index}>
          {console.log(key,value,'KKKKKK')}
          <div className="content_div">
            <div className="key_wrapper">
              <span className="key">{formatKey(key)}</span>
            </div>
            <div className="key_wrapper">
              {/* Check if the key is "productImage" and value starts with "http" */}
              {key === "mainImages" && value[0].startsWith("http") ? (
                value.map(image => <img src={image} alt="Product" style={{ width: "100px", height: "100px" }} /> )
                
              ) : (
                // Check if the key is "storeImage" and value starts with "http"
                key === "storeImage" && value.startsWith("http") ? (
                  <img src={value} alt="Store" style={{ width: "100px", height: "100px" }} />
                ) : (
                  <span className="value">{value}</span>
                )
              )}
            </div>
          </div>
          <hr />
        </div>
      ))}
    </>

    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <div className="details_container">
          <Detailsrender object={data} />
        </div>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ViewDetail;
